import { useGeoLookupContext } from '@/hooks/useGeoLookupContext';
import { config } from '@/pageConfig/renters/us/en';
import { RentersPageTemplate } from '@/pageTemplate/RentersPageTemplate';
import { useEffect } from 'react';

export default function RentersPage() {
  const { trackEventWithGeolocation } = useGeoLookupContext();
  // biome-ignore lint/correctness/useExhaustiveDependencies: want to track event only once
  useEffect(
    () =>
      trackEventWithGeolocation('renters_page.viewed', {
        variant: 'default_a',
      }),
    [],
  );

  return (
    <RentersPageTemplate
      config={{
        ...config,
        seo: {
          ...config.seo,
          uniqueCanonicalUrl: 'https://www.lemonade.com/renters',
        },
      }}
    />
  );
}
